// Maximum speed
export const MAX_SPEED = 140;
// Minimum speed
export const MIN_SPEED = 70;
// Speed unit
export const SPEED_UNIT = 'KMH';
// Speed steps
export const SPEED_STEPS = 10;
// Maximum temperature
export const MAX_TEMP = 40;
// Minimum temperature
export const MIN_TEMP = -10;
// Temperature unit
export const TEMP_UNIT = 'º';
// Temperature steps
export const TEMP_STEPS = 10;
// AC/heat temperature limit
export const AC_HEAT_LIMIT = 10;
// Speed unit
export const STAT_UNIT = 'KM';
// Default speed
export const DEFAULT_SPEED = 100;
// Default temperature
export const DEFAULT_TEMP = 10;
// Default fan status
export const DEFAULT_FAN_STATUS = false;
// Default wheel size
export const DEFAULT_WHEEL_SIZE = 19;
// Default 100d distance
export const DEFAULT_100D_DISTANCE = 581;
// Default p100d distance
export const DEFAULT_P100D_DISTANCE = 559;
